import { Grid, Typography } from "@material-ui/core";
import { StreakIcon } from "../../icons";
import { useStyles } from "./streak-day.styles";

type StreakDayProps = {
  day: string;
  isSelected: boolean;
  isStreak: boolean;
};

export const StreakDay = ({ day, isSelected, isStreak }: StreakDayProps) => {
  const classes = useStyles({ isSelected, isStreak });

  return (
    <Grid
      container
      direction="column"
      alignContent="center"
      alignItems="center"
      justifyContent="center"
      className={classes.dayContainer}
      data-testid={day}
    >
      <StreakIcon />
      <Typography>{day}</Typography>
    </Grid>
  );
};
